import { filesListId, filesId, bottomTabbarId } from '../../../../../../../config/constants.js';

export default (ev, id) => {
    const changeAmount = $$(filesListId).count();
    const cellsOption = $$(bottomTabbarId).getOption(filesId);
    cellsOption.value = id ? `Файлы(${changeAmount - 1})` : `Файлы(${changeAmount})`;
    $$(bottomTabbarId).refresh();
};
